<app-v4-navbar></app-v4-navbar>
<header>
  <app-header-new [headerTitle]="'CONTACT US'"></app-header-new>
</header>
<main class="tw-px-5 md:tw-px-[14%] 2xl:tw-px-[18%] tw-py-10">
  <!-- Form and image  -->
  <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-10 tw-items-center">
    <div class="tw-basis-full md:tw-basis-1/2">
      <img
        fetchpriority="high"
        decoding="async"
        src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/Showroom-768x746.jpg"
        class="tw-w-full"
        alt="Nuhome Living Ltd"
        title="Showroom"
      />
    </div>
    <div class="tw-basis-full md:tw-basis-1/2">
      <h2 class="tw-text-2xl md:tw-text-3xl tw-font-poppins tw-font-bold tw-text-center">
        Contact Us Today!
      </h2>
      <div class="tw-mt-6 md:tw-mt-10">
        <form
          [formGroup]="generalContactFrom"
          (ngSubmit)="onContactFormSubmit()"
        >
          <div class="tw-mt-2 tw-font-poppins">
            <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
              >Name*</label
            >
            <input
              type="text"
              placeholder="Enter your name"
              name="contact-name"
              class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
              formControlName="name"
            />
            @if (f['name'].invalid && (f['name'].dirty || f['name'].touched)) {
            <div class="tw-mt-1 tw-text-xs tw-text-red-500">
              @if (f['name'].errors && f['name'].errors['required']) {
              <span>Name is required.</span>
              } @if (f['name'].errors && f['name'].errors['minlength']) {
              <span>Name should be at least 2 charactors.</span>
              } @if (f['name'].errors && f['name'].errors['maxlength']) {
              <span>Name should not exceed 200 charactors.</span>
              }
            </div>
            }
          </div>
          <div class="tw-mt-2 tw-font-poppins">
            <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
              >Email*</label
            >
            <input
              type="email"
              placeholder="Enter your email address"
              name="contact-email"
              class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
              formControlName="email"
            />
            @if (f['email'].invalid && (f['email'].dirty || f['email'].touched))
            {
            <div class="tw-mt-1 tw-text-xs tw-text-red-500">
              @if (f['email'].errors && f['email'].errors['required']) {
              <span>Email is required.</span>
              } @if (f['email'].errors && f['email'].errors['email']) {
              <span>Invalid email.</span>
              }
            </div>
            }
          </div>
          <div class="tw-mt-2 tw-font-poppins">
            <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
              >MESSAGE*</label
            >
            <textarea
              rows="4"
              placeholder="Write your message here"
              class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
              formControlName="message"
            ></textarea>
            @if (f['message'].invalid && (f['message'].dirty ||
            f['message'].touched)) {
            <div class="tw-mt-1 tw-text-xs tw-text-red-500">
              @if (f['message'].errors && f['message'].errors['required']) {
              <span>Message is required</span>
              } @if (f['message'].errors && f['message'].errors['minlength']) {
              <span>Message should be at least 2 charactors.</span>
              } @if (f['message'].errors && f['message'].errors['maxlength']) {
              <span>Message should not exceed 1000 charactors.</span>
              }
            </div>
            }
          </div>

          <div class="tw-mt-2 tw-font-poppins">
            @if (captchaEnabled) {
            <div class="tw-mt-4 tw-mb-4 tw-flex tw-flex-row tw-justify-center">
              <re-captcha
                (resolved)="onCaptchaResolved($event)"
                siteKey="6LcOs2oqAAAAALe5pWwYlnM7__pJ0NugcGC7lgCz"
              ></re-captcha>
            </div>
            }
          </div>

          <div class="tw-mt-5">
            <button
              type="submit"
              class="tw-w-full tw-py-2.5 tw-px-5 tw-border-2 tw-bg-black tw-text-white tw-font-poppins tw-font-bold"
              [ngClass]="{
                'tw-opacity-100 tw-cursor-pointer':
                  generalContactFrom.valid &&
                  ((captchaEnabled && captchaResolved) || !captchaEnabled),
                'tw-opacity-50 tw-cursor-not-allowed':
                  generalContactFrom.invalid ||
                  (captchaEnabled && !captchaResolved)
              }"
              [disabled]="
                generalContactFrom.valid &&
                ((captchaEnabled && captchaResolved) || !captchaEnabled)
                  ? false
                  : true
              "
            >
              SEND
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Form and image  -->

  <!-- Contact Details -->
  <div class="tw-mt-16 md:tw-mt-20 tw-flex tw-flex-col md:tw-flex-row tw-gap-5 md:tw-gap-0">
    <div class="tw-basis-full md:tw-basis-1/2 tw-text-center">
      <p class="tw-text-base tw-text-center tw-font-poppins">
        Phone: <strong>01206 700 599</strong>
      </p>
      <p class="tw-mt-2 tw-text-base tw-text-center tw-font-poppins">
        Email: <strong>{{ "support@nustone.co.uk" }}</strong>
      </p>
      <p class="tw-mt-4 tw-text-center">
        <a href="https://wa.me/441206700599" class="tw-flex tw-justify-center">
          <img
            loading="lazy"
            decoding="async"
            class="tw-h-14"
            src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/WhatsAppButtonGreenMedium.webp"
            alt=""
          />
        </a>
      </p>
    </div>
    <div class="tw-basis-full md:tw-basis-1/2 tw-text-center">
      <p class="tw-text-base tw-text-center tw-font-poppins">
        <strong>Monday: </strong> 08:00 – 17:00
      </p>
      <p class="tw-mt-1 tw-text-base tw-text-center tw-font-poppins">
        <strong>Tuesday: </strong> 08:00 – 17:00
      </p>
      <p class="tw-mt-1 tw-text-base tw-text-center tw-font-poppins">
        <strong>Wednesday: </strong> 08:00 – 17:00
      </p>
      <p class="tw-mt-1 tw-text-base tw-text-center tw-font-poppins">
        <strong>Thursday: </strong> 08:00 – 17:00
      </p>
      <p class="tw-mt-1 tw-text-base tw-text-center tw-font-poppins">
        <strong>Friday: </strong> 08:00 – 17:00
      </p>
      <p class="tw-mt-1 tw-text-base tw-text-center tw-font-poppins">
        <strong>Saturday: </strong> 08:00 – 17:00
      </p>
      <p class="tw-mt-1 tw-text-base tw-text-center tw-font-poppins">
        <strong>Sunday: </strong> 08:00 – 17:00
      </p>
      <p class="tw-mt-3 tw-text-base tw-text-center tw-font-poppins">
        <strong>Bank Holidays: </strong> Closed
      </p>
    </div>
  </div>
  <!-- Contact Details -->

  <!-- trustbox -->
  <div class="tw-w-full tw-py-10">
    <app-trustbox [template_Id]="'53aa8912dec7e10d38f59f36'" [height]="'140px'" [width]="'100%'"></app-trustbox>
  </div>
  <!-- trustbox -->

  <hr class="tw-my-16 md:tw-my-20" />

  <div class="tw-mt-5 md:tw-mt-10 tw-flex tw-flex-col md:tw-flex-row tw-gap-5 tw-items-center">
    <div class="tw-basis-full md:tw-basis-3/5">
      <h2 class="tw-text-center tw-text-2xl md:tw-text-3xl tw-font-bold tw-font-poppins">
        Need A Quote?
      </h2>
      <h3
        class="tw-mt-8 tw-text-xl tw-tracking-tight tw-font-poppins tw-text-center tw-font-bold"
      >
        No problem!
      </h3>
      <p class="tw-mt-4 tw-text-base tq-text-center tw-font-poppins">
        Just fill out the form below and we’ll email you the details of your
        quote.
      </p>
      <p class="tw-mt-4 tw-text-base tq-text-center tw-font-poppins">
        Please make sure to include the full name and size of the products that
        you require so that we can put your quote together as quickly as
        possible!
      </p>
    </div>
    <div class="tw-basis-full md:tw-basis-2/5">
      <img
        decoding="async"
        class="tw-w-auto"
        src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/Samples-3-350x350.webp"
        alt="Paving Prices"
        title="Samples-3"
        loading="lazy"
      />
    </div>
  </div>

  <!-- get a quote -->
  <div class="tw-mt-10">
    <form [formGroup]="getQuoteFrom" (ngSubmit)="onGetQuoteFormSubmit()">
      <div class="tw-mt-2 tw-font-poppins">
        <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
          >Full Name*</label
        >
        <input
          type="text"
          placeholder="Enter your full name"
          name="quote-name"
          class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
          formControlName="name"
        />
        @if (fs['name'].invalid && (fs['name'].dirty || fs['name'].touched)) {
        <div class="tw-mt-1 tw-text-xs tw-text-red-500">
          @if (fs['name'].errors && fs['name'].errors['required']) {
          <span>Full Name is required.</span>
          } @if (fs['name'].errors && fs['name'].errors['minlength']) {
          <span>Full Name should be at least 2 charactors.</span>
          } @if (fs['name'].errors && fs['name'].errors['maxlength']) {
          <span>Full Name should not exceed 200 charactors.</span>
          }
        </div>
        }
      </div>
      <div class="tw-mt-2 tw-font-poppins">
        <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
          >Company Name - If Applicable</label
        >
        <input
          type="text"
          placeholder="Enter your company name"
          name="quote-company"
          class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
          formControlName="companyName"
        />
        @if (fs['companyName'].invalid && (fs['companyName'].dirty ||
        fs['companyName'].touched)) {
        <div class="tw-mt-1 tw-text-xs tw-text-red-500">
          @if (fs['companyName'].errors &&
          fs['companyName'].errors['minlength']) {
          <span>Company Name should be at least 2 charactors.</span>
          } @if (fs['companyName'].errors &&
          fs['companyName'].errors['maxlength']) {
          <span>Company Name should not exceed 200 charactors.</span>
          }
        </div>
        }
      </div>
      <div class="tw-mt-2 tw-font-poppins">
        <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
          >Email Address*</label
        >
        <input
          type="email"
          placeholder="Enter your email address"
          name="quote-email"
          class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
          formControlName="email"
        />
        @if (fs['email'].invalid && (fs['email'].dirty || fs['email'].touched)) {
        <div class="tw-mt-1 tw-text-xs tw-text-red-500">
          @if (fs['email'].errors && fs['email'].errors['required']) {
          <span>Email is required.</span>
          } @if (fs['email'].errors && fs['email'].errors['email']) {
          <span>Invalid email.</span>
          }
        </div>
        }
      </div>
      <div class="tw-mt-2 tw-font-poppins">
        <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
          >Phone Number*</label
        >
        <input
          type="tel"
          placeholder="Enter your phone number"
          name="quote-phone"
          class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
          formControlName="phoneNumber"
        />
        @if (fs['phoneNumber'].invalid && (fs['phoneNumber'].dirty ||
        fs['phoneNumber'].touched)) {
        <div class="tw-mt-1 tw-text-xs tw-text-red-500">
          @if (fs['phoneNumber'].errors && fs['phoneNumber'].errors['required']) {
          <span>Phone number is required.</span>
          } @if (fs['phoneNumber'].errors && fs['phoneNumber'].errors['pattern']) {
          <span>Phone number is invalid.</span>
          }
        </div>
        }
      </div>
      <div class="tw-mt-2 tw-font-poppins">
        <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
          >Exact Product Required - Copy this from the product page to be sure
          that you get the right quote!</label
        >
        <input
          type="text"
          placeholder="Enter the product name"
          name="quote-product"
          class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
          formControlName="productRequired"
        />
        @if (fs['productRequired'].invalid && (fs['productRequired'].dirty ||
        fs['productRequired'].touched)) {
        <div class="tw-mt-1 tw-text-xs tw-text-red-500">
          @if (fs['productRequired'].errors &&
          fs['productRequired'].errors['minlength']) {
          <span>Product Name should be at least 10 charactors.</span>
          } @if (fs['productRequired'].errors &&
          fs['productRequired'].errors['maxlength']) {
          <span>Product Name should not exceed 300 charactors.</span>
          }
        </div>
        }
      </div>
      <div class="tw-mt-2 tw-font-poppins">
        <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
          >Coverage Required - In M²</label
        >
        <input
          type="number"
          placeholder="Enter the coverage"
          name="quote-coverage"
          class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
          formControlName="coverageRequired"
        />
        @if (fs['coverageRequired'].invalid && (fs['coverageRequired'].dirty ||
        fs['coverageRequired'].touched)) {
        <div class="tw-mt-1 tw-text-xs tw-text-red-500">
          @if (fs['coverageRequired'].errors &&
          fs['coverageRequired'].errors['min']) {
          <span>Coverage cannot be less than 0.</span>
          }
        </div>
        }
      </div>
      <div class="tw-mt-2 tw-font-poppins">
        <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
          >Delivery Postcode*</label
        >
        <input
          type="text"
          placeholder="Enter the delivery post code"
          name="quote-postcode"
          class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
          formControlName="deliveryPostcode"
        />
        @if (fs['deliveryPostcode'].invalid && (fs['deliveryPostcode'].dirty ||
        fs['deliveryPostcode'].touched)) {
        <div class="tw-mt-1 tw-text-xs tw-text-red-500">
          @if (fs['deliveryPostcode'].errors &&
          fs['deliveryPostcode'].errors['required']) {
          <span>Delivery postcode is required.</span>
          } @if (fs['deliveryPostcode'].errors &&
          fs['deliveryPostcode'].errors['minlength']) {
          <span>Delivery postcode should be at least 1 charactors.</span>
          } @if (fs['deliveryPostcode'].errors &&
          fs['deliveryPostcode'].errors['maxlength']) {
          <span>Delivery postcode should not exceed 50 charactors.</span>
          }
        </div>
        }
      </div>
      <div class="tw-mt-2 tw-font-poppins">
        <label class="tw-uppercase tw-font-bold tw-text-[10.6px]"
          >Any Other Questions</label
        >
        <input
          type="text"
          placeholder="Enter if you have any other questions"
          name="quote-questions"
          class="tw-font-poppins tw-w-full tw-text-xs tw-text-black tw-p-3.5 tw-bg-nu-gray tw-opacity-80"
          formControlName="additionQuestions"
        />
        @if (fs['additionQuestions'].invalid && (fs['additionQuestions'].dirty
        || fs['additionQuestions'].touched)) {
        <div class="tw-mt-1 tw-text-xs tw-text-red-500">
          @if (fs['additionQuestions'].errors &&
          fs['additionQuestions'].errors['minlength']) {
          <span>Additional questions should be at least 2 charactors.</span>
          } @if (fs['additionQuestions'].errors &&
          fs['additionQuestions'].errors['maxlength']) {
          <span>Additional questions should not exceed 400 charactors.</span>
          }
        </div>
        }
      </div>
      <div class="tw-mt-2 tw-font-poppins">
        @if (captchaEnabled) {
        <div class="tw-mt-4 tw-mb-4 tw-flex tw-flex-row tw-justify-center">
          <re-captcha
            (resolved)="onCaptchaResolved($event)"
            siteKey="6LcOs2oqAAAAALe5pWwYlnM7__pJ0NugcGC7lgCz"
          ></re-captcha>
        </div>
        }
      </div>
      <div class="tw-mt-4 tw-font-poppins">
        <button
          type="submit"
          class="tw-py-2.5 tw-px-5 tw-border-2 tw-bg-black tw-text-white tw-font-poppins tw-font-bold"
          [ngClass]="{
            'tw-opacity-100 tw-cursor-pointer':
              getQuoteFrom.valid &&
              ((captchaEnabled && captchaResolved) || !captchaEnabled),
            'tw-opacity-50 tw-cursor-not-allowed':
              getQuoteFrom.invalid || (captchaEnabled && !captchaResolved)
          }"
          [disabled]="
            getQuoteFrom.valid &&
            ((captchaEnabled && captchaResolved) || !captchaEnabled)
              ? false
              : true
          "
        >
          REQUEST A QUOTE
        </button>
      </div>
    </form>
  </div>
  <!-- get a quote -->

  <hr class="tw-my-20" />

  <div class="tw-mt-20 tw-flex tw-flex-col tw-gap-5 tw-items-center">
    <div class="tw-text-center tw-text-sm tw-font-poppins">
      <p class="tw-font-bold tw-text-center">Address:</p>
      <p class="tw-mt-4 tw-text-center">Nuhome Living Ltd</p>
      <p class="tw-text-center">Dobbies Lane</p>
      <p class="tw-text-center">Marks Tey</p>
      <p class="tw-text-center">Colchester</p>
      <p class="tw-text-center">Essex</p>
      <p class="tw-text-center">CO6 1EP</p>
      <p class="tw-mt-4 tw-text-center">
        <strong> Registration No</strong>: 17340311
      </p>
      <p class="tw-mt-4 tw-text-center">
        <strong> VAT No</strong>: GB 525 9726 61
      </p>
    </div>
    <figure class="wpb_wrapper vc_figure">
      <a href="https://www.bali.org.uk/?inventory=1387" target="_blank">
        <img
          loading="lazy"
          decoding="async"
          src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/BALI-Accredited-primary-logo-SITE-300x214.png"
          alt="BALI Accredited"
          title=""
        />
      </a>
    </figure>
  </div>
</main>
<app-footer></app-footer>
